import { DateTime } from 'src_common/utils/time/time';

export const PERIODS = [ 'today', '3-days', '7-days', 'week', 'month' ];

export default function getPeriodTime(id) {
    switch (id) {
    case 'today':
        return {
            startDate: DateTime.current().format('YYYY-MM-DDT00:00:00'),
            endDate: DateTime.current().format('YYYY-MM-DDT23:59:59')
        };
    case '3-days':
        return {
            startDate: DateTime.current().subtractDays(3).format('YYYY-MM-DDT00:00:00'),
            endDate: DateTime.current().format('YYYY-MM-DDT23:59:59')
        };
    case '7-days':
        return {
            startDate: DateTime.current().subtractDays(7).format('YYYY-MM-DDT00:00:00'),
            endDate: DateTime.current().format('YYYY-MM-DDT23:59:59')
        };
    case 'week':
        return {
            startDate: DateTime.current().startOfIsoWeek().format('YYYY-MM-DDT00:00:00'),
            endDate: DateTime.current().format('YYYY-MM-DDT23:59:59')
        };
    case 'month':
        return {
            startDate: DateTime.current().startOfMonths().format('YYYY-MM-DDT00:00:00'),
            endDate: DateTime.current().format('YYYY-MM-DDT23:59:59')
        };
    }
}

export function getPeriod(from, to) {
    const fromDateTime = DateTime.from(from);
    const toDateTime = DateTime.from(to);

    from = fromDateTime !== null ? fromDateTime.format('YYYY-MM-DDT00:00:00') : '';
    to = toDateTime !== null ? toDateTime.format('YYYY-MM-DDT23:59:59') : '';

    for (let period of PERIODS) {
        let time = getPeriodTime(period);

        if (time.startDate === from && time.endDate === to) {
            return period;
        }
    }

    return 'custom';
}
